import { render } from "./BFaceRefundButton.vue?vue&type=template&id=7201b600"
import script from "./BFaceRefundButton.vue?vue&type=script&lang=js"
export * from "./BFaceRefundButton.vue?vue&type=script&lang=js"
script.render = render

export default script